import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { requestAxios, ComboBox } from "../../../../util/util";
import AppContext from "../../../../Context/AppContext";
import "./ModalAdicion.css";

const ModalAdicion = ({
  show,
  setShow,
  setCurrentRow,
  currentRow,
  acreditadoInfo,
  loadInfo,
}) => {
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const [validated, setValidated] = useState(false);
  const infoUs = checkUserSession();

  function setDataRow(field, data) {
    let newRow = { ...currentRow };
    newRow[field] = data;
    setCurrentRow(newRow);
  }
  async function saveData() {
    changeLoading(true);
    const PostObj = {
      ...currentRow,
      AcreditadoId: acreditadoInfo.AcreditadoId,
      FechaAltaDireccion: new Date(),
      Activa: true,
    };
    if(PostObj.Telefono.length!==10){
      changeLoading(false);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Error!</strong>,
        html: (
          <i>
            El teléfono tiene que tener 10 dígitos.
          </i>
        ),
        icon: "warning",
      });
      return false;
    }
    const { error, data } = await requestAxios({
      url: `Acreditados/${
        currentRow.Id === 0 ? "INuevaDireccion" : "UNuevaDireccion"
      }`,
      method: currentRow.Id === 0 ? "post" : "put",
      token: infoUs.bearer_token,
      data: PostObj,
    });
    if (error === "") {
      changeLoading(false);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Hecho!</strong>,
        html: <i>Guardado con éxito!</i>,
        icon: "success",
      });
      setShow(false);
      loadInfo();
    } else {
      alert("Error, try again");
    }
    changeLoading(false);
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === true) {
      saveData();
    }
  };
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90wNuevasDirecciones"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="AcreditadoDetalleModalTitle"
          className="ModalDomiciliosModalTitle"
        >
          Agregar: <span>Nueva Dirección</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="modalAdicionNuevasDireccion__container">
            <TextField
              id="outlined-basic"
              label="Nombre"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Nombre"]}
              onChange={(input) => setDataRow("Nombre", input.target.value)}
              required={true}
            />
            <TextField
              id="outlined-basic"
              label="Dirección, colonia y municipio"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Direccion"]}
              onChange={(input) => setDataRow("Direccion", input.target.value)}
              required={true}
            />
            <TextField
              id="outlined-basic"
              label="Telefono."
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Telefono"]}
              type="number"
              required={true}
              onChange={(input) => {
                if (String(input.target.value).length <= 10) {
                  setDataRow("Telefono", input.target.value);
                }
              }}
            />

            <TextField
              id="outlined-basic"
              label="Parentesco"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["Propietario"]}
              required={true}
              onChange={(input) =>
                setDataRow("Propietario", input.target.value)
              }
            />
          </div>

          <div className="modalAdicion__buttoncontainer modalAdicion__buttoncontainerDirecciones">
            <button
              className="modalAdicion__btnCancelar"
              type="button"
              onClick={() => setShow(false)}
            >
              Cancelar
            </button>
            <button className="modalAdicion__btnRegistrar" type="submit">
              Guardar
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
